import { render, staticRenderFns } from "./LinkAssetInfo.vue?vue&type=template&id=0324fb14&scoped=true&"
import script from "./LinkAssetInfo.vue?vue&type=script&lang=js&"
export * from "./LinkAssetInfo.vue?vue&type=script&lang=js&"
import style0 from "./LinkAssetInfo.vue?vue&type=style&index=0&id=0324fb14&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0324fb14",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VFlex,VLayout})
